/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'heartbeat': {
    width: 16,
    height: 16,
    viewBox: '0 0 66.76 58.35',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M10.62 41.57c5.28 5.66 12.64 11 22.11 16.08.1 0 .1.1.2.1H33c.1 0 .3.1.41.1a.61.61 0 0 0 .41-.1h.1c.1 0 .1 0 .2-.1 14.29-7.6 23.81-16 28.57-25l.79-1.6-19.82.07-5.44-14.42-7.7 26.85-8.62-18.26L17.37 35H5.52l-1-1.57A29.34 29.34 0 0 1 .5 18.64 18.31 18.31 0 0 1 14.69.91c7-1.62 14.39 1.72 18.64 8.21C37.69 2.63 45-.72 52.08.91a18.31 18.31 0 0 1 14.18 17.73 28.43 28.43 0 0 1-.65 6" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/heartbeat.js